// extracted by mini-css-extract-plugin
export default {"contactMe":"Services_contactMe__dKP8I","contactInfo":"Services_contactInfo__wzaA1"};